export function isFirefoxClient() {
  return (
    !!(window && window.navigator) &&
    navigator.userAgent.toLowerCase().indexOf("firefox") > -1
  );
}
